import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { flexCenterMixin } from 'styles/mixins'

export const FilledPanel = styled.div`
  flex: 1 0 40%;
  position: relative;
  aspect-ratio: 1/1;

  display: flex;
  align-items: center;
  justify-content: center;

  .loading-spinner {
    z-index: 1;
    position: absolute;
  }
`

export const ImageWrapper = styled.div<{ $hoverText: string }>`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 16px;
  border: 1px solid ${COLORS.borderColor};
  overflow: hidden;
  cursor: pointer;
  ${flexCenterMixin()}

  &::after {
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    content: '${({ $hoverText }) => $hoverText}';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(53, 62, 90, 0.7);
    ${flexCenterMixin()}
    color: ${COLORS.white};
    font-size: 14px;
    font-weight: 500;
  }

  &:hover::after {
    opacity: 1;
  }
`

export const PanelImage = styled.img<{ $isLoading?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.5s ease-in-out;
`

export const RemoveIconWrapper = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
  ${flexCenterMixin()}
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease-in-out;

  &:hover {
    svg {
      fill: ${COLORS.secondarySemiDark};
    }
  }
`
